export default __webpack_public_path__ + "static/media/round.fdadfa9b.png";